import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  onSearchDistribuidorClick,
  onUpdateFieldFilter,
  onSearchProvinciaClick,
  onSearcMunicipioClick,
  onSearchVendedorPorRolClick,
} from "../../../store/clientes/baseclientes/actions";

import { ActionField, FieldSet } from "@sigeco/tools";
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import { Icon } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import {getDistribuidorDefault} from '../../../helpers/commons';

const useStyles = makeStyles(() => ({
  content: {
    padding: "0.5rem 0.75rem 0.75rem",
  },
  filterClear: {
    display: "flex",
  },
  actionField: {
    flexDirection: "row",
    position: "relative",
  },
  btnClear: {
    position: "absolute",
    bottom: "1.5",
    right:20,
    maxWidth: "15px",
    maxHeight: "23px",
    minWidth: "15px",
    minHeight: "23px",
  },
  root: {
    flex: "0 0 auto",
    marginBottom: "0.75rem",
    "@media (min-width: 1401px)": {
      marginBottom: "1rem",
    },
  },
}));

const BaseClientesFilter = () => {
  const classes = useStyles();
  const matches = useMediaQuery("(min-width:701px)");
  const filters = useSelector((state) => state.baseclientes.filters);
  const dispatch = useDispatch();

  useEffect(() =>{

    getDistribuidorDefault(onUpdateFieldFilter,dispatch);

  },[])

  //Estados de Limpiar filtros
  const [, setDistribuidor] = useState("");
  const [btn, setBtn] = useState(true);
  const [, setDepartamento] = useState("");
  const [btn1, setBtn1] = useState(true);
  const [, setMunicipio] = useState("");
  const [btn2, setBtn2] = useState(true);
  const [, setName] = useState("");
  const [btn4, setBtn4] = useState(true);
  const [, setVendedor] = useState("");
  const [btn5, setBtn5] = useState(true);

  useEffect(() => {
    if (filters.dDistribuidor) {
      setDistribuidor(filters.dDistribuidor);
      setBtn(false);
    } else {
      setBtn(true);
    }
  }, [filters.dDistribuidor]);

  useEffect(() => {
    if (filters.dVendedor) {
      setVendedor(filters.dVendedor);
      setBtn5(false);
    } else {
      setBtn5(true);
    }
  }, [filters.dVendedor]);

  useEffect(() => {
    if (filters.dDepartamento) {
      setDepartamento(filters.dDepartamento);
      setBtn1(false);
    } else {
      setBtn1(true);
    }
  }, [filters.dDepartamento]);

  useEffect(() => {
    if (filters.dMunicipio) {
      setMunicipio(filters.dMunicipio);
      setBtn2(false);
    } else {
      setBtn2(true);
    }
  }, [filters.dMunicipio]);

  useEffect(() => {
    if (filters.nombre) {
      setName(filters.nombre);
      setBtn4(false);
    } else {
      setBtn4(true);
    }
  }, [filters.nombre]);

  const handleDist = () => {
    setDistribuidor("");
    setVendedor("");
    setDepartamento("");
    setMunicipio("");
    setName("");
    filters.distribuidorId = 0;
    filters.dDistribuidor = "";
    filters.vendedorId = 0;
    filters.dVendedor = "";
    filters.departamentoId = "";
    filters.dDepartamento = "";
    filters.municipioId = "";
    filters.dMunicipio = "";
    filters.nombre = "";

    setBtn(true);
    setBtn1(true);
    setBtn2(true);
    setBtn4(true);
    setBtn5(true);
  };
  const handleVendedor = () => {
    setVendedor("");
    setDepartamento("");
    setMunicipio("");
    setName("");

    filters.vendedorId = 0;
    filters.dVendedor = "";
    filters.departamentoId = 0;
    filters.dDepartamento = "";
    filters.municipioId = "";
    filters.dMunicipio = "";
    filters.nombre = "";
    setBtn5(true);
    setBtn1(true);
    setBtn2(true);
    setBtn4(true);
  };
  const handleDepartamento = () => {
    setDepartamento("");
    setMunicipio("");
    setName("");
    filters.departamentoId = 0;
    filters.dDepartamento = "";
    filters.municipioId = "";
    filters.dMunicipio = "";
    filters.nombre = "";
    setBtn1(true);
    setBtn2(true);
    setBtn4(true);
  };
  const handleMunicipio = () => {
    setMunicipio("");
    setName("");
    filters.municipioId = '';
    filters.dMunicipio = "";
    filters.nombre = "";
    setBtn2(true);
    setBtn4(true);
  };
  
  const handleName = () => {
    setName("");
    filters.nombre = "";
    setBtn4(true);
  };

  function onFieldChange(event) {
    dispatch(onUpdateFieldFilter(event.target.name, event.target.value));
  }

  return (
    <div className={classes.root}>
      <FieldSet
        iconCls="fas fa-filter"
        title="Filtros"
        defaultExpanded
        expandable
      >
        <Grid className={classes.content} container spacing={2}>
          <Grid item xs={12} container>
            <Grid item xs={matches ? 4 : 12}>
              <FormControl className={classes.filterClear}>
                <ActionField
                  className={classes.actionField}
                  label="Agente"
                  placeholder="Enter para buscar Agente"
                  value={filters.dDistribuidor}
                  variant={matches ? "outlined" : "standard"}
                  onHandleAction={() => dispatch(onSearchDistribuidorClick())}
                />
                <Button
                  className={classes.btnClear}
                  size="small"
                  startIcon={<Icon className="fa fa-window-close" />}
                  disabled={btn}
                  onClick={handleDist}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container item xs={12}  >
          
          <Grid item  xs={matches ? 4 : 12}>
          <FormControl className={classes.filterClear}>
            <ActionField
              label="Vendedor"
              placeholder="Enter para buscar Vendedor"
              value={filters.dVendedor}
              variant={matches ? "outlined" : "standard"}
              onHandleAction={() => dispatch(onSearchVendedorPorRolClick())}
            />
            <Button
              className={classes.btnClear}
              size="small"
              startIcon={<Icon className="fa fa-window-close" />}
              disabled={btn5}
              onClick={handleVendedor}
            />
          </FormControl>
          </Grid>
        
      </Grid>
          <Grid item xs={12} container>
            <Grid item xs={matches ? 4 : 12}>
              <FormControl className={classes.filterClear}>
                <ActionField
                  className={classes.actionField}
                  label="Departamento"
                  placeholder="Enter para buscar Departamento"
                  value={filters.dDepartamento}
                  variant={matches ? "outlined" : "standard"}
                  onHandleAction={() => dispatch(onSearchProvinciaClick())}
                />
                <Button
                  className={classes.btnClear}
                  size="small"
                  startIcon={<Icon className="fa fa-window-close" />}
                  disabled={btn1}
                  onClick={handleDepartamento}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12} container>
            <Grid item xs={matches ? 4 : 12}>
              <FormControl className={classes.filterClear}>
                <ActionField
                  className={classes.actionField}
                  label="Provincia"
                  placeholder="Enter para buscar Provincia"
                  value={filters.dMunicipio}
                  variant={matches ? "outlined" : "standard"}
                  onHandleAction={() => dispatch(onSearcMunicipioClick())}
                />
                <Button
                  className={classes.btnClear}
                  size="small"
                  startIcon={<Icon className="fa fa-window-close" />}
                  disabled={btn2}
                  onClick={handleMunicipio}
                />
              </FormControl>
            </Grid>
          </Grid>
          {/* <Grid item xs={12} container>
            <Grid item xs={matches ? 4 : 12}>
              <FormControl className={classes.filterClear}>
                <ActionField
                  className={classes.actionField}
                  label="Ubigeo"
                  placeholder="Enter para buscar ubigeo"
                  value={ubigeo}
                  variant={matches ? "outlined" : "standard"}
                  onHandleAction={() => dispatch(onSearchUbigeoClick())}
                />
                <Button
                  className={classes.btnClear}
                  size="small"
                  startIcon={<Icon className="fa fa-window-close" />}
                  disabled={btn3}
                  onClick={handleUbigeo}
                />
              </FormControl>
            </Grid>
          </Grid> */}
          <Grid item xs={matches ? 6 : 12}>
            <FormControl className={classes.filterClear}>
              <TextField
                autoComplete="off"
                fullWidth
                label="Nombres de cliente"
                name="nombre"
                value={ filters.nombre}
                variant={matches ? "outlined" : "standard"}
                onChange={onFieldChange}
              />
              <Button
                style={{right:0}}
                className={classes.btnClear}
                size="small"
                startIcon={<Icon className="fa fa-window-close" />}
                disabled={btn4}
                onClick={handleName}
              />
            </FormControl>
          </Grid>
        </Grid>
      </FieldSet>
    </div>
  );
};

export default BaseClientesFilter;
